import React, {useEffect, useState} from 'react';

import Button from "components/Button/Button";
import styleCom from "./REGCOM.module.scss";
import DataGrid from "../../components/DataGrid/DataGrid";
import {postData} from 'utils/TransactionUtil';
import Table from "../../components/Table/Table";
import style from "./REG300F1.module.scss";
import Radio2 from "../../components/Radio/Radio2";
import DatePicker from "../../components/DatePicker/DatePicker";
import {dateToYMD, ymdToDate} from "./REGComUtil";
import RadioGroup from "../../components/Radio/RadioGroup";
import InputUnitText from "../../components/InputText/InputUnitText";
import Checkbox from "../../components/Checkbox/Checkbox";
import TextArea from "../../components/TextArea/TextArea";
import toast from "../../components/Toast/Toast";

const REG300M3 = ({handle_Close, mstId, hsptCd,  comHandleClick_Save}) => {


    const [dsReg, setDsReg] = useState( {
         mstId:mstId
        ,hsptCd:hsptCd
        ,reviewTitle:""
        ,reviewNote:""
    });
    const setDsRegValue = (name, value) => {
        setDsReg(prev => ({
            ...prev,
            [name]: value
        }));
    }


    useEffect(() => {
        //(공통) 모달 창 "확인(적용)" 버튼 클릭
        comHandleClick_Save(() => {
            if(validate()){
                svcRecMainQuery();
            }

        });
    }, [comHandleClick_Save]);

    /* Call Service====================================================================================================*/
    async function svcRecMainQuery() {
        const param = dsReg;
        let result = await postData("/REW/setReviewRegMain", param);

        if(result===1){
            toast({ type: 'info', message: '등록이 완료되었습니다.'});
            handle_Close(true);
        }else{
            toast({ type: 'error', message: '등록이 실패하였습니다.'});
            handle_Close(false);
        }
    }

    //데이터 셋팅 및 유효성 검사
    const validate = () => {
        let checkCnt = 0;
        let valid = false;

        if(dsReg.reviewTitle.length<1){
            valid = false;
            toast({ type: 'warning', message: '제목을 입력하여 주십시오.'});
        }else if(dsReg.reviewNote.length<1){
            valid = false;
            toast({ type: 'warning', message: '내용을 입력하여 주십시오.'});
        }else{
            valid = true;
        }
        return  valid;
    };


    return(

        <main>

            <div className={styleCom.title_wrap}>
                <h3>제목</h3>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", padding: "20px"}}>
                <InputUnitText type={"text"} maxLength={50}
                               width={"700px"}
                               value={dsReg.reviewTitle}
                               onChange={(value) => setDsRegValue("reviewTitle", value)}/>
            </div>
            <div className={styleCom.title_wrap}>
                <h3>상세내용</h3>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", padding: "20px"}}>

                <TextArea value={dsReg.reviewNote} maxLength={500}
                          onChange={(value) => setDsRegValue("reviewNote", value)}
                          width={"700px"} height={"200px"}/>
            </div>


        </main>
    )
}
export default REG300M3;